//add all cities data
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import {
  Add_Area,
  Delete_Area,
  Get_All_Area,
  Get_Error,
  Get_One_Area,
  Update_One_Area,
} from '../Types';
import usegetdata from '../../Hooks/useGetData';
import usedeletedata from '../../Hooks/useDeleteData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';

export const Add_Area_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/Area`, body);

    dispatch({
      type: Add_Area,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all cities data
export const GetAllAreaData = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Area?active=true`);

    dispatch({
      type: Get_All_Area,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const GetAllAreaDataTrash = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Area?active=false`);

    dispatch({
      type: Get_All_Area,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one Area data
export const DeleteOneAreaData = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/Area/${id}`);

    dispatch({
      type: Delete_Area,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all Area data
export const GetOneAreaData = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Area/${id}`);

    dispatch({
      type: Get_One_Area,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update one Area data
export const UpdateOneAreaData = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/Area/${id}`, body);

    dispatch({
      type: Update_One_Area,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
